<script setup lang="ts">
import type { Partner, UpdatePartnerDto } from '@/api-swagger'
import { defineProps, ref } from 'vue'
import { usePartnerStore } from '@/stores/usePartnerStore'
import Modal from '@/components/common/layout/Modal.vue'
import IconPencilSquare from '@/assets/icons/pencil-square.svg'
import { storeToRefs } from 'pinia'
import { useToast } from 'vue-toast-notification'
import { VQuillEditor } from '@morpheme/quill-editor'
import { useForm } from 'vee-validate'
import { object, string } from 'yup'
import '@morpheme/quill-editor/dist/style.css'
import SaveButton from '@/components/common/buttons/SaveButton.vue'

const schema = object({
  content: string().required().label('Content'),
})

const { values } = useForm({
  validationSchema: schema,
})

const showModal = ref<boolean>(false)
const $toast = useToast()

const props = defineProps({
  partner: {
    type: Object as () => Partner,
    required: true,
  },
})

const partnerStore = usePartnerStore()
const { loading } = storeToRefs(partnerStore)

const onSubmit = async () => {
  const updatePartner: UpdatePartnerDto = {
    comment: values.comment,
  }

  await partnerStore
    .updatePartner(props.partner.id, updatePartner)
    .then((res) => {
      Object.assign(props.partner, res)
      $toast.success('Client modifié avec succès.')
      closeModal()
    })
    .catch((error) => {
      $toast.error(error.message)
    })
}

function openModal() {
  showModal.value = true
}

function closeModal() {
  showModal.value = false
}
</script>

<template>
  <div class="tooltip" data-tip="Editer">
    <component :is="IconPencilSquare" @click="openModal" class="cursor-pointer" />
  </div>
  <Modal :showModal="showModal" @close="closeModal" :title="partner!.name" :loading="loading">
    <template #content>
      <div class="grid gap-3">
        <div class="flex gap-3 mb-5">
          <div class="form-control w-full">
            <label class="label" for="partner-note">
              <span class="label-text"><strong>Notes :</strong></span>
            </label>
            <form @submit.prevent="onSubmit" class="border-none">
              <VQuillEditor
                name="comment"
                v-model="partner!.comment"
                placeholder="Ajouter une note"
              />
              <SaveButton :loading="loading" />
            </form>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>
